import React from "react"
import AuthWrapper from "components/AuthWrapper"

export const wrapRootElement = ({ element }) => {
  return <AuthWrapper>{element}</AuthWrapper>
}
